import script from "./SettingsItemSentiment.vue?vue&type=script&setup=true&lang=js"
export * from "./SettingsItemSentiment.vue?vue&type=script&setup=true&lang=js"

import "./SettingsItemSentiment.vue?vue&type=style&index=0&id=b3aef084&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-b3aef084"]])

export default __exports__